import { IStoreState } from "../state/state";

interface IFeeConfig {
	[locale: string]: {
		name: string,
		wiypName: string,
		value: number
	}[]
}

export default {
	fees: (state: IStoreState) => {
		const lang = state.language as string;

		const feeConfig: IFeeConfig = {
			"fr-FR": [
				{
					name: "fileFees",
					wiypName: "fileFees_WIYP",
					value: 24,
				},
			],
			"nl-NL": [
				{
					name: "fileFees",
					wiypName: "fileFees_WIYP",
					value: 24,
				},
				{
					name: "NL_Calamiteitenfonds",
					wiypName: "NL_Calamiteitenfonds_WIYP",
					value:
						state.participants.length < 10
							? 2.5
							: state.participants.length < 19
							? 5
							: 7.5,
				},
				{
					name: "NL_SGRcontribution",
					wiypName: "NL_SGRcontribution_WIYP",
					value: 5 * state.participants.filter((age) => age > 1).length,
				},
			],
			"en-US": [
				{
					name: "fileFees",
					wiypName: "fileFees_WIYP",
					value: 24,
				},
			],
		};

		return feeConfig[lang];
	},
};
